// Grid.jsx
import React, { forwardRef } from 'react';
import GridItem from './GridItem';
import GridTitle from './GridTitle';
import useScrollOpacity from './useScrollOpacity';

const Grid = forwardRef(({ gridItems, setIsOpen, setMediaSrcHighRes, setMediaType, setMetaData }, ref) => {
    
    const gridRef = useScrollOpacity(
        false, 
        250, 
        250, 
        null, 
        { enabled: false, maxBlur: 50, inverse: false },
        true, // disable opacity changes
        { enabled: false, minSaturate: 100, maxSaturate: 150, inverse: false }
    );

    let previousFragmentID = null;
    return (
        <div ref={gridRef} className='grid'>
            {gridItems.map((item, index) => {
                let gridTitle = null;
                if (item.fragmentID !== previousFragmentID) {
                    previousFragmentID = item.fragmentID;
                    gridTitle = (
                        <GridTitle 
                            key={`title-${index}`} 
                            item={item}
                        />
                    );
                }
                return (
                    <React.Fragment key={index}>
                        {gridTitle}
                        <GridItem 
                            key={item.id} 
                            item={item} 
                            setIsOpen={setIsOpen}
                            setMediaSrcHighRes={setMediaSrcHighRes}
                            setMediaType={setMediaType}
                            setMetaData={setMetaData}
                        />
                    </React.Fragment>
                );
            })}
        </div>
    );
});

export default Grid;